import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { map, timeout } from 'rxjs/operators';
import { EventsService } from './eventsService';
import { StringConstants } from '../_store/stringConstants';
@Injectable({
  providedIn: 'root'
})
export class HttpUtilityService {
  private localHttp: HttpClient;

  constructor(
    private http: HttpClient,
    private eventsService: EventsService,
    handler: HttpBackend
  ) {
    this.localHttp = new HttpClient(handler);
  }

  httpPost(req, reqURL, options = {}, uiOptions = { showWait: true }): Observable<any> {
    this.setAppBusy(reqURL)
    return this.http.post(reqURL, req, options).pipe(
      timeout(10000),
      map(
        response => {
          if (uiOptions.showWait) {
            this.setAppIdle()
          }
          return response;
        }
      )
    );
  }

  httpPostResponseObject(req, reqURL, options = {}, uiOptions = { showWait: true }): Observable<any> {
    this.setAppBusy(reqURL)

    return this.http.post(reqURL, req, {observe: 'response'}).pipe(
      timeout(10000),
      map(
        response => {
          if (uiOptions.showWait) {
            this.setAppIdle()
          }
          return response;
        }
      )
    );
  }

  httpGet(reqURL, options): Observable<any> {
    return this.http.get(reqURL, options).pipe(
      timeout(5000),
      map(
        response => {
          return response;
        }
      )
    );
  }

  httpMultiPart(reqURL, req) {
    this.setAppBusy(true);
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type': 'multipart/form-data'
      })
    };
    return this.localHttp.post(reqURL, req, httpOptions).pipe(
        map(
          response => {
            this.setAppBusy(false);
            return response;
          }
        )
      );
    }

  private setAppBusy(reqUrl) {
    this.eventsService.triggerEvent(StringConstants.EVENTS.APP_BUSY, { reqUrl });
  }

  private setAppIdle() {
    this.eventsService.triggerEvent(StringConstants.EVENTS.APP_IDLE);
  }

}
